import { css, styled } from 'styled-components';

export const Container = styled.div``;

export const ContentArea = styled.div``;

export const DisplayArea = styled.div`
  ${({ theme: { fontSizes } }) => css`
    display: flex;

    .filter-button {
      border-style: dashed;
      border-radius: 0.25rem;
      font-size: ${fontSizes.s14};
      padding: 0 0.75rem;

      .icon {
        aspect-ratio: 1 / 1;
        font-size: unset;
        height: 1rem;
        width: 1rem;

        path {
          stroke-width: 1.33;
        }
      }
    }
  `}
`;

export const FiltersArea = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 0 0.5rem;
  width: -webkit-fill-available;

  .clear-button {
    border-radius: 0.25rem;
  }
`;

export const Filter = styled.div`
  ${({ theme: { colors, fontSizes, fontWeights } }) => css`
    align-items: center;
    background: ${colors.brandDarkTint95};
    border-radius: 0.25rem;
    cursor: pointer;
    display: flex;
    gap: 0.25rem;
    padding: 0.25rem 0.25rem 0.25rem 0.5rem;
    user-select: none;

    p {
      font-size: ${fontSizes.s12};
      font-weight: ${fontWeights.medium};
      margin: 0;
    }

    div {
      align-items: center;
      display: flex;
      gap: 0.25rem;

      img {
        object-fit: cover;
        object-position: center;
        border-radius: 1rem;
        width: 1rem;
        height: 1rem;
      }

      .icon {
        width: 1rem;
        height: 1rem;
      }

      span {
        font-size: ${fontSizes.s12};
        line-height: 1.25rem;
      }

      .avatar {
        align-items: center;
        background: ${colors.brandPrimary};
        border-radius: 1rem;
        display: flex;
        height: 1rem;
        justify-content: center;
        width: 1rem;

        p {
          font-size: 0.625rem;
          line-height: 1em;
          margin: 0;
          padding: 0;
        }
      }
    }

    .button {
      border-radius: 0.25rem;
      height: 1.5rem;
      width: 1.5rem;
      min-width: unset;

      .icon {
        font-size: unset;
        height: 1rem;
        width: 1rem;
      }
    }
  `}
`;

export const DropArea = styled.div`
  ${({ theme: { colors, fontSizes } }) => css`
    background: ${colors.brandLight};
    border-radius: 0.25rem;
    box-shadow:
      0 0 0 1px ${colors.brandDarkTint80},
      0 0.75rem 0.5rem -0.25rem rgba(32, 30, 36, 0.15),
      0 0.25rem 0.25rem -0.125rem rgba(32, 30, 36, 0.2);
    min-width: 14rem;
    padding: 0;
    overflow: hidden;

    ul {
      margin: 0;
      max-height: 23rem;
      overflow-y: auto;
      overscroll-behavior: contain;
      padding: 0.5rem;

      &::-webkit-scrollbar {
        height: 8px;
        width: 8px;
      }

      &::-webkit-scrollbar-track {
        background: white;
      }

      &::-webkit-scrollbar-thumb {
        background-clip: padding-box;
        background-color: ${colors.brandDarkTint80};
        border-radius: 8px;
        height: 8px;
        -webkit-border-radius: 8px;
      }

      &::-webkit-scrollbar-thumb:hover {
        background-color: ${colors.brandDarkTint70};
      }
    }

    .input {
      label {
        padding: 0;

        input {
          font-size: ${fontSizes.s14};
          padding: 0 1rem 0 0.5rem;
        }

        .icon {
          height: 1rem;
          width: 1rem;

          path {
            stroke: ${colors.brandDarkTint30};
          }
        }
      }
    }

    @media all and (min-height: 0px) and (max-height: 599px) {
      ul {
        max-height: 40svh;
      }
    }
  `}
`;

export const SubdropArea = styled.div<{ $isVisible: boolean; x: number; y: number }>`
  ${({ $isVisible, x, y }) => css`
    display: none;
    position: fixed;
    left: calc(${x}px + 0.5rem);
    top: calc(${y}px - 1.25rem);
    z-index: 1;
    padding-left: 0.875rem;

    ${
      $isVisible &&
      css`
        display: block;
      `
    }
  `}
`;

export const DropItem = styled.div<{ $isSearch?: boolean; $isDisabled?: boolean }>`
  ${({ theme: { colors, fontWeights }, $isDisabled, $isSearch }) => css`
    align-items: center;
    border-radius: 0.25rem;
    color: ${colors.brandDark};
    cursor: ${$isDisabled ? 'not-allowed' : 'pointer'};
    display: flex;
    justify-content: space-between;
    padding: 0.625rem 0.5rem;
    position: relative;
    user-select: none;

    &::before {
      content: ' ';
      display: block;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      z-index: 1;
    }

    .icon {
      height: 1rem;
      width: 1rem;
    }

    .ds-checkbox {
      gap: 0;

      span {
        height: 1.25em;
        width: 1.25em;
        flex-shrink: 0;
        flex-grow: 0;
      }

      [data-testid='checkbox-label'] {
        display: none !important;
      }

      input {
        width: 100%;
        height: 100%;
      }
    }

    p {
      margin: 0;
    }

    ${
      $isSearch &&
      css`
        font-weight: ${fontWeights.medium};
      `
    }

    &:hover {
      background: ${colors.brandPrimaryAlpha5};
    }

    ${
      $isDisabled &&
      css`
        p {
          color: ${colors.brandDarkTint30};
        }

        .icon {
          opacity: 0.4;
        }

        &:hover {
          background: transparent;
        }
      `
    }
  `}
`;

export const Label = styled.p`
  ${({ theme: { fontSizes } }) => css`
    display: flex;
    font-size: ${fontSizes.s14};
    flex-direction: column;
    line-height: 1.25em;
    flex: 1;
  `}
`;

export const RightLabel = styled.p`
  ${({ theme: { colors, fontSizes } }) => css`
    color: ${colors.brandDarkTint30};
    font-size: ${fontSizes.s12};
    font-style: italic;
    line-height: 1.25em;
    padding-left: 1rem;
  `}
`;

export const Group = styled.div`
  align-items: center;
  display: flex;
  gap: 0.5rem;
`;

export const LabelGroup = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  gap: 0.5rem;
  width: 100%;
`;

export const Thumbnail = styled.div`
  align-items: center;
  border-radius: 1rem;
  display: flex;
  height: 1rem;
  justify-content: center;
  overflow: hidden;
  width: 1rem;

  img {
    height: 100%;
    object-fit: cover;
    object-position: center;
    width: 100%;
  }
`;

export const SmallAvatar = styled.div<{ $avatarColor?: string; $isDisabled?: boolean }>`
  ${({ theme: { colors, fontWeights }, $avatarColor, $isDisabled }) => css`
    align-items: center;
    background: ${$avatarColor || colors.brandPrimary};
    border-radius: 1rem;
    display: flex;
    flex-shrink: 0;
    height: 1rem;
    justify-content: center;
    opacity: ${$isDisabled ? 0.4 : 1};
    overflow: hidden;
    width: 1rem;

    p {
      color: ${colors.brandLight};
      font-size: 0.6rem;
      font-weight: ${fontWeights.semiBold};
      line-height: 1em;
      margin: 0;
      padding: 0;
    }
  `}
`;

export const Avatar = styled.div<{ $useBackground?: boolean; $avatarColor?: string }>`
  ${({ theme: { colors }, $useBackground, $avatarColor }) => css`
    align-items: center;
    border-radius: 0.5rem;
    display: flex;
    flex: 0 0 auto;
    height: 2rem;
    justify-content: center;
    position: relative;
    width: 2rem;

    ${
      $useBackground &&
      css`
        background: ${$avatarColor || colors.brandPrimary};
      `
    }

    &::before {
      border-radius: inherit;
      box-shadow: inset 0 0 0 1px ${colors.brandDarkAlpha20};
      content: '';
      display: block;
      height: 100%;
      left: 0;
      pointer-events: none;
      position: absolute;
      top: 0;
      user-select: none;
      width: 100%;
      z-index: 1;
    }

    img {
      border-radius: 0.5rem;
      height: 100%;
      object-fit: cover;
      width: 100%;
    }
  `}
`;

export const NetworkBadge = styled.div`
  ${({ theme: { colors } }) => css`
    align-items: center;
    background: ${colors.brandLight};
    border-radius: 0.5rem;
    bottom: -0.25rem;
    box-shadow: 0 0 0 1px ${colors.brandLight};
    display: flex;
    height: 1rem;
    justify-content: center;
    position: absolute;
    right: -0.25rem;
    width: 1rem;
    z-index: 1;

    .icon {
      height: 0.875rem;
      width: 0.875rem;
      padding: 0;
    }
  `}
`;

export const CustomSpan = styled.span`
  ${({ theme: { colors, fontSizes } }) => css`
    color: ${colors.brandDarkTint30};
    font-size: ${fontSizes.s12};
    line-height: 1em;
  `}
`;

export const SearchText = styled.p`
  ${({ theme: { colors, fontSizes } }) => css`
    box-sizing: border-box;
    color: ${colors.brandDark};
    cursor: pointer;
    font-size: ${fontSizes.s14};
    margin: 0;
    padding: 0.5rem;
    width: 100%;

    &:hover {
      background: ${colors.brandPrimaryAlpha5};
    }
  `}
`;

export const EmptySearchText = styled.p`
  ${({ theme: { colors, fontSizes } }) => css`
    color: ${colors.brandDarkTint50};
    font-size: ${fontSizes.s14};
    margin: 0;
    padding: 0.5rem 0;
    text-align: center;
    width: 100%;
  `}
`;
